import type { AxiosRequestConfig } from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';
import type { OrderCustomizationResponse } from './use-get-order-customization';
import { webviewHttpClient } from '@/app/[locale]/(order)/components/auth/webview-http-client';

interface OrderCustomizationParams {
  item_id: number;
  skip?: number;
  limit?: number;
}

export interface OrderCustomizationParamsWithToken
  extends OrderCustomizationParams {
  token: string;
}

export const getOrderCustomizationWSFn = async (
  params: OrderCustomizationParamsWithToken,
  config: AxiosRequestConfig = {}
): Promise<OrderCustomizationResponse> => {
  const { token, ...requestParams } = params;

  const response = await webviewHttpClient.get<OrderCustomizationResponse>(
    apiRoutes.ahafood.store.get_order_customization,
    {
      ...config,
      params: requestParams,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response?.data;
};

export const useGetOrderCustomizationWS = (
  token: string,
  params: OrderCustomizationParams,
  opts?: Omit<
    UseQueryOptions<OrderCustomizationResponse, Error>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<OrderCustomizationResponse, Error>({
    queryKey: [apiRoutes.ahafood.store.get_order_customization],
    queryFn: () => getOrderCustomizationWSFn({ ...params, token }),
    ...opts,
  });
};
